(() => {
  const init = root => {
    if (root.dataset.collectionReady) return;
    root.dataset.collectionReady = 'true';
    const form = root.querySelector('[data-collection-form]');
    const mobile = root.querySelector('[data-mobile-filters]');
    const groups = root.querySelector('.pc-filter-groups');
    const sort = root.querySelector('.pc-sort');
    const toolbar = root.querySelector('.pc-toolbar');
    const toggle = root.querySelector('[data-filter-toggle]');
    const dialog = root.querySelector('[data-collection-drawer]');
    const body = dialog.querySelector('.pc-drawer-body');
    const media = matchMedia('(max-width: 989px)');
    const setMobile = () => {
      if (!toggle) return;
      if (media.matches) {
        groups.querySelectorAll('input,button').forEach(input => input.setAttribute('form', form.id));
        sort.querySelector('select').setAttribute('form', form.id);
        body.append(sort, groups);
        toggle.querySelector('span').textContent = root.dataset.mobileLabel;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', dialog.id);
      } else {
        dialog.close();
        mobile.append(groups);
        toolbar.append(sort);
        mobile.open = true;
        const hidden = root.querySelector('[data-collection-layout]').classList.contains('is-filter-hidden');
        toggle.querySelector('span').textContent = hidden ? toggle.dataset.show : toggle.dataset.hide;
        toggle.setAttribute('aria-expanded', String(!hidden));
        toggle.setAttribute('aria-controls', root.querySelector('.pc-aside').id);
      }
    };
    dialog.id = `CollectionDrawer-${form.id}`;
    setMobile();
    media.addEventListener('change', setMobile);
    toggle?.addEventListener('click', () => {
      if (media.matches) { dialog.showModal(); document.documentElement.classList.add('pc-drawer-open'); toggle.setAttribute('aria-expanded', 'true'); return; }
      const hidden = root.querySelector('[data-collection-layout]').classList.toggle('is-filter-hidden');
      toggle.setAttribute('aria-expanded', String(!hidden));
      toggle.querySelector('span').textContent = hidden ? toggle.dataset.show : toggle.dataset.hide;
    });
    dialog.querySelector('[data-collection-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) dialog.close(); } });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('pc-drawer-open'); if (media.matches && toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); } });
    root.querySelectorAll('[data-collection-view]').forEach(button => button.addEventListener('click', () => {
      root.querySelector('[data-product-grid]').classList.toggle('is-list', button.dataset.collectionView === 'list');
      root.querySelectorAll('[data-collection-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    form?.addEventListener('submit', () => {
      [...form.elements].filter(input => input.type === 'number').forEach(input => { if (!input.value) input.disabled = true; });
    });
    root.querySelector('[data-collection-sort]')?.addEventListener('change', () => form.requestSubmit());
    root.dataset.collectionEnhanced = 'true';
  };
  document.querySelectorAll('[data-collection-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-collection-section]').forEach(init));
})();
